import React from "react"
import styled from "styled-components"
import { replace, get } from "lodash"
import moment from "moment"
import { FormNavigationContext } from "../../../Panes/Form"
import { media } from "../../../../components/mediaStyles"
import { getColor, colors } from "../../../../components/Color"
import Question from "../Question"

const LoadingSection = styled.div`
  text-align: center;
  font-family: GT America, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const InformationTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${media.tablet`
   max-width: 500px;
   margin-left: 15px;
   `}

  > table {
    margin-bottom: 10px !important;
  }
`

const InformationRow = styled.tr`
  font-family: GT America, sans-serif;
  > td:first-child {
    color: ${getColor("primary", 0.6)};
  }
`

const EditButton = styled.div`
  font-family: GT America, sans-serif;
  color: ${colors.teal};

  ${media.tablet`
   margin-left: 15px;
   `}

  &:hover {
    font-weight: 600;
    cursor: pointer;
  }
`

export default class Summary extends React.Component {
  state = {
    percentage: 0,
  }

  fillFormResults(text) {
    return replace(text, /(\${.*?})/g, variable => {
      const variableName = variable.replace(/\$|{|}/g, "")
      return get(this.context.result, variableName, "-") || "-"
    })
  }

  renderRow = row => {
    let value = get(this.context.result, row.value, "")
    if (moment.isMoment(value)) {
      value = value.format("DD.MM.YYYY")
    }
    return (
      <InformationRow key={`Summary-Row-${row.key}`}>
        <td>{row.key}</td>
        <td>{value || "-"}</td>
      </InformationRow>
    )
  }

  render() {
    return (
      <LoadingSection>
        <Question {...this.props.question} />

        <InformationTable>
          <table>
            <tbody>{this.props.identifierList.map(this.renderRow)}</tbody>
          </table>
        </InformationTable>
        {this.props.editIdentifier && (
          <EditButton
            onClick={() =>
              this.props.navigateTo(this.props.editIdentifier, true)
            }
          >
            Editieren
          </EditButton>
        )}
      </LoadingSection>
    )
  }
}

Summary.contextType = FormNavigationContext
